/* istanbul ignore file */
export enum SaleStateStatusEnum {
    NO_SALE = 'no_sale',
    SOLD = 'sold',
    PENDING_SALE = 'pending_sale'
}
